import {
  MEMBER_ROLE_LABELS,
  type TenantMember,
  approvalGroupLabel,
} from '../../service/membership';

type Props = {
  member: TenantMember;
  /** The signed-in admin's own row. */
  isSelf: boolean;
  showApprovalGroups: boolean;
  isEditing: boolean;
  disabled: boolean;
  onEdit(): void;
};

const STATUS_LABELS: Record<string, string> = { active: 'Active', invited: 'Invited' };

/** One read-only row of the members table; editing happens in MemberEditor below it. */
export default function MemberRow({
  member,
  isSelf,
  showApprovalGroups,
  isEditing,
  disabled,
  onEdit,
}: Props) {
  return (
    <tr className="govuk-table__row">
      <td className="govuk-table__cell">
        <span>{member.email}</span>
        {isSelf && (
          <>
            {' '}
            <strong className="govuk-tag govuk-tag--grey">You</strong>
          </>
        )}
      </td>
      <td className="govuk-table__cell">
        <strong
          className={`govuk-tag ${member.status === 'active' ? 'govuk-tag--green' : 'govuk-tag--blue'}`}
        >
          {STATUS_LABELS[member.status] || member.status}
        </strong>
      </td>
      <td className="govuk-table__cell">{MEMBER_ROLE_LABELS[member.role] || member.role}</td>
      {showApprovalGroups && (
        <td className="govuk-table__cell">
          {member.approvalGroups.length === 0 ? (
            <span className="govuk-hint govuk-!-margin-0">None</span>
          ) : (
            <ul className="govuk-list govuk-!-margin-0">
              {member.approvalGroups.map((group) => (
                <li key={group} className="govuk-!-margin-bottom-1">
                  {approvalGroupLabel(group)}
                </li>
              ))}
            </ul>
          )}
        </td>
      )}
      <td className="govuk-table__cell govuk-table__cell--numeric">
        <button
          type="button"
          className="govuk-button govuk-button--secondary govuk-!-margin-bottom-0"
          onClick={onEdit}
          disabled={disabled}
          aria-expanded={isEditing}
        >
          Change<span className="govuk-visually-hidden"> {member.email}</span>
        </button>
      </td>
    </tr>
  );
}
